// extracted by mini-css-extract-plugin
export default {"header":"CpsUDFbjnOBXrMA_fU9G","headerIcon":"wWAkoWzcX3abM3tR9TEL","container":"zn3VN8MUO8vhn_Xe7H7Y","body":"PRHRr96ykXu5iINU2XWR","browse":"QEUDb8B7SBfDSJv9d4Ai"};